import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiCardMain]',
    standalone: false
})
export class CardMainDirective {
  @HostBinding('class') className = 'lui-card-main-content';
}
